import Tabs from '../../../components/Tabs';
import { getCurrentUser } from '../../../services/CurrentUser';
import { CYCLE, TEAM, createQuery } from '../../../services/HeaderSearchBar';

const tabs = [
    {
        header: <span>Team</span>,
        trackingLabel: 'team tab',
    },
    {
        header: <span>Cycles</span>,
        trackingLabel: 'cycles tab',
    },
];

const IDS = {
    [TEAM]: 0,
    [CYCLE]: 1,
};

export default function Navigation({ mode, search, doSelectItem }) {
    const tabsProps = {
        tabs,
        onSelect: index => {
            doSelectItem(null);
            search(createQuery(getType(index), getCurrentUser()));
        },
        selectedIndex: getSelectedId(mode),
        eventTracking: { category: 'navigation header search bar', action: 'toggle' },
    };

    return <Tabs compact={true} fullWidth={true} {...tabsProps} />;
}

function getType(index) {
    return [TEAM, CYCLE][index];
}

function getSelectedId(mode) {
    return IDS[mode];
}
